<template>
    <v-container class="fill-height">
        <v-row>
            <v-col>
                <v-row justify="center">
                    <div class="text-h4 text-center font-weight-black">Velkommen til søknadsportalen <span class="text-no-wrap" :style="{color: appColors.background}">{{user.firstname}} {{user.lastname}}</span></div>
                </v-row>

                <br>

                <v-row justify="center">
                    <div class="text-center" style="max-width:90%;">Alle søknader til Sparebankstiftelsen Telemark - Holla og Lunde skal leveres digital gjennom denne portalen. Vi har laget denne enkel og brukervennlig. Les instruksjoner over hver knapp hvis du er usikker.</div>
                </v-row>

                <v-row class="my-8"></v-row>

                <v-row align-content="center" justify="center">
                    <v-col cols="12" sm="4" lg="3">
                        <v-card @click="() => {$router.push({path:'/application/0'})}" outlined class="ma-auto py-3" :style="{border: `2px solid ${appColors.primary1}`, 'background-color': appColors.grey5, 'border-radius': '5px'}" :max-width="$vuetify.breakpoint.smAndUp? undefined : '90%'">
                            <v-card-title>
                                <v-icon x-large class="ma-auto">mdi-hand-heart</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <div class="text-subtitle-1 text-center text-no-wrap">Ny søknad</div>
                            </v-card-text>
                        </v-card>

                    </v-col>
                    <v-col cols="12" sm="4" lg="3">
                        <v-card @click="() => {$router.push({name:'applications'})}" outlined class="ma-auto py-3" :style="{border: `2px solid ${appColors.primary1}`, 'background-color': appColors.grey5, 'border-radius': '5px'}" :max-width="$vuetify.breakpoint.smAndUp? undefined : '90%'">
                            <v-card-title>
                                <v-icon x-large class="ma-auto">mdi-cash-multiple</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <div class="text-subtitle-1 text-center text-no-wrap">Oversikt søknader</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="4" lg="3">
                        <v-card @click="() => {$router.push({name:'users'})}" outlined class="ma-auto py-3" :style="{border: `2px solid ${appColors.primary1}`, 'background-color': appColors.grey5, 'border-radius': '5px'}" :max-width="$vuetify.breakpoint.smAndUp? undefined : '90%'">
                            <v-card-title>
                                <v-icon x-large class="ma-auto">mdi-account-multiple</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <div class="text-subtitle-1 text-center text-no-wrap">Brukere</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
import { colors as appColors } from "../utilities/colors";
import colors from 'vuetify/lib/util/colors';

export default {
    data() {
        return {
            user: this.$store.getters.user,
            appColors: appColors,
            vueColors: colors,
        };
    }
}
</script>

<style lang="scss" scoped>

</style>